// TokenService.ts
let token: string | null = null;

export const TokenService = {
  setToken: (newToken: string) => {
    token = newToken;
  },
  getToken: (): string | null => {
    return token;
  },
};
